import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.sass'

export function CarouselNavControls({
  onPrev,
  onNext,
  inactiveLeft,
  inactiveRight,
}) {
  return (
    <div className={styles.navigationControls}>
      <button
        aria-label="Previous"
        className={classNames(styles.navButton, {
          [styles.inactiveButton]: inactiveLeft,
        })}
        onClick={onPrev}
        type="button"
      >
        <FontAwesomeIcon icon="chevron-left" />
      </button>
      <button
        aria-label="Next"
        className={classNames(styles.navButton, {
          [styles.inactiveButton]: inactiveRight,
        })}
        onClick={onNext}
        type="button"
      >
        <FontAwesomeIcon icon="chevron-right" />
      </button>
    </div>
  )
}

CarouselNavControls.propTypes = {
  inactiveLeft: PropTypes.bool,
  inactiveRight: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
}
